import { request } from '../utils/request';

const pathwayuIntegrationAPIs = {
  // Get all hubs for PathwayU integration
  getAllHubs: () => request.get('/admin/pathwayu/hubs'),

  // Get PathwayU companies
  getPathwayUCompanies: () => request.get('/admin/pathwayu/companies'),

  // Create PathwayU integration
  createIntegration: data => request.post('/admin/pathwayu/integrate', data),

  // Get migration status for a hub
  getMigrationStatus: hubId =>
    request.get(`/admin/pathwayu/migration-status/${hubId}`),

  // Clear failed migration for a hub
  clearFailedMigration: hubId =>
    request.delete(`/admin/pathwayu/clear-failed-migration/${hubId}`),
};

export default pathwayuIntegrationAPIs;
